type ENV = 'development' | 'production' | 'test' | 'stg'
export const env: ENV = import.meta.env.VITE_APP_ENV ?? 'development'

export const appHost: string = import.meta.env.VITE_APP_HOST ?? 'http://localhost:5012'
export const apiHost: string = import.meta.env.VITE_API_HOST ?? 'http://localhost:5012'
export const gtmId: string = import.meta.env.VITE_GTM_ID ?? ''
export const sentryDsn: string = import.meta.env.VITE_SENTRY_DSN ?? ''
